import { useState, useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import useGet from '../../hooks/useGet';
import { debounce } from 'lodash';

function useProductTable() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchValue, setSearchValue] = useState(searchParams.get('search_query') || '');
  
  const initialData = {
    page_number: searchParams.get('page_number') || 0,
    limit: searchParams.get('limit') || 10,
    search_query: searchParams.get('search_query') || ''
  };

  const { data, paramsObject, setParamsObject } = useGet({
    url: 'get-product-list',
    initialParams: initialData
  });

  // Debounced function to update search params
  const debouncedSearch = useCallback(
    debounce((value) => {
      const updatedParams = {
        ...paramsObject,
        search_query: value
      };
      setSearchParams(updatedParams);
      setParamsObject(updatedParams);
    }, 500),
    [paramsObject, setSearchParams, setParamsObject]
  );

  // Handle search input change
  const handleSearchVal = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    debouncedSearch(value);
  };
  
  const handlePageClick = (val) => {
    const pageParams = {
      ...paramsObject,
      page_number: val.selected
    };
    setParamsObject(pageParams);
    setSearchParams(pageParams);
  };

  const handleSetLimit = (e) => {
    const value = e.target.value;
    const updatedParams = {
      ...paramsObject,
      limit: value
    };
    setSearchParams(updatedParams);
    setParamsObject(updatedParams);
  };

  return {
    data,
    paramsObject,
    searchValue,
    handleSearchVal,
    handlePageClick,
    handleSetLimit
  };
}

export default useProductTable;
